import { handleActions } from 'redux-actions';

import {
  mobilePatrolsSuccess,
  mobilePatrolInfoSuccess,
  deselectMobilePatrols,
  updateMobilePatrolsStatusSuccess,
  mobilePatrolTagsSuccess,
  updateMobilePatrolTagSuccess,
  disableMobilePatrolTagSuccess,
  enableMobilePatrolTagSuccess,
  deleteMobilePatrolTagSuccess,
} from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';
import { ENTITY_STATUS } from 'app/types/constants';

export default handleActions(
  {
    [mobilePatrolsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [mobilePatrolInfoSuccess](state, { payload: { data } }) {
      return {
        ...state,
        selected: data,
      };
    },
    [deselectMobilePatrols](state) {
      return {
        ...state,
        selected: null,
      };
    },
    [updateMobilePatrolsStatusSuccess](state, { payload: { status } }) {
      return {
        ...state,
        selected: {
          ...state.selected,
          status,
        },
      };
    },
    [mobilePatrolTagsSuccess](state, { payload: { mobilePatrolID, tags } }) {
      return {
        ...state,
        tags: {
          ...state.tags,
          [mobilePatrolID]: tags,
        },
      };
    },
    [updateMobilePatrolTagSuccess](state, { payload: { mobilePatrolID, tagID, payload } }) {
      return {
        ...state,
        tags: {
          ...state.tags,
          [mobilePatrolID]: state.tags[mobilePatrolID].map((tag) =>
            tag.tagID === tagID ? { ...tag, ...payload } : tag
          ),
        },
      };
    },
    [disableMobilePatrolTagSuccess](state, { payload: { mobilePatrolID, tagID } }) {
      return {
        ...state,
        tags: {
          ...state.tags,
          [mobilePatrolID]: state.tags[mobilePatrolID].map((tag) =>
            tag.tagID === tagID ? { ...tag, status: ENTITY_STATUS.SUSPENDED } : tag
          ),
        },
      };
    },
    [enableMobilePatrolTagSuccess](state, { payload: { mobilePatrolID, tagID } }) {
      return {
        ...state,
        tags: {
          ...state.tags,
          [mobilePatrolID]: state.tags[mobilePatrolID].map((tag) =>
            tag.tagID === tagID ? { ...tag, status: ENTITY_STATUS.ACTIVE } : tag
          ),
        },
      };
    },
    [deleteMobilePatrolTagSuccess](state, { payload: { mobilePatrolID, tagID } }) {
      return {
        ...state,
        tags: {
          ...state.tags,
          [mobilePatrolID]: state.tags[mobilePatrolID].filter((tag) => tag.tagID !== tagID),
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
